/**
 * @internal
 */
export var Surface;
(function (Surface) {
    Surface["base"] = "base";
    Surface["raised"] = "raised";
})(Surface || (Surface = {}));
/**
 * @internal
 */
export var DialogVariant;
(function (DialogVariant) {
    DialogVariant["normal"] = "normal";
    DialogVariant["sidebar"] = "sidebar";
})(DialogVariant || (DialogVariant = {}));
/**
 * The stylistic variants available to the buttons used by these components.
 */
export var EButtonVariants;
(function (EButtonVariants) {
    EButtonVariants["default"] = "default";
    EButtonVariants["primary"] = "primary";
    EButtonVariants["tinted"] = "tinted";
    EButtonVariants["text"] = "text";
})(EButtonVariants || (EButtonVariants = {}));
/**
 * The stylistic variants available to the avatars used by these components.
 */
export var EAvatarVariant;
(function (EAvatarVariant) {
    EAvatarVariant["human"] = "human";
    EAvatarVariant["entity"] = "entity";
    EAvatarVariant["bot"] = "bot";
})(EAvatarVariant || (EAvatarVariant = {}));
//# sourceMappingURL=types.js.map